import { render, staticRenderFns } from "./type.vue?vue&type=template&id=4e106960&scoped=true"
import script from "./type.vue?vue&type=script&lang=js"
export * from "./type.vue?vue&type=script&lang=js"
import style0 from "./type.vue?vue&type=style&index=0&id=4e106960&lang=css"
import style1 from "./type.vue?vue&type=style&index=1&id=4e106960&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e106960",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e106960')) {
      api.createRecord('4e106960', component.options)
    } else {
      api.reload('4e106960', component.options)
    }
    module.hot.accept("./type.vue?vue&type=template&id=4e106960&scoped=true", function () {
      api.rerender('4e106960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/toursCombine/tcSetting/type.vue"
export default component.exports